/**
 * Created by CoolGuy on 2017/4/11.
 */
import { combineReducers } from 'redux';
import actions from '../actions';
import AjaxAction from '../actions/AjaxAction';
import rateReducer from './rateReducer';
import allocationReducer from "./allocationReducer";
import checkReducer from "./checkingReducer";
import {get, set} from 'idb-keyval';
// import {actionFor} from '../util/CheckList';

//主要用在Product,Bill,Agreement等上
let newCurrentX = (name,state,action)=>{
    let capitalName = name.toUpperCase();
    switch (action.type){
        // case  actions[`FILL_CURRENT_${capitalName}`]:
        //     return action.data;
        case actions[`REMOVE_CURRENT_${capitalName}`]:
            return {};
        case AjaxAction[`${capitalName}_DETAIL`]:
            return action.data;
        default:
            return state;
    }

};


let demo = (state = "",action)=>{
    switch (action.type){
        case actions.DEMO:
            return action.data;
        default:
            return state;
    }
};
//所有显示层的东西放这里了
let ui = (state = {}, action)=> {
    switch (action.type) {
        case actions.FULL_CONTENT:
            return {...state, fullContent: action.flag};
        case actions.SHOW_IM:
            return {...state, showIMDetail: action.flag};
        case actions.SHOW_ADD_DEPARTMENT:
            return {...state, showAddDepartment: action.flag, currentDepartment:action.current}
        case actions.SHOW_ADD_USER:
            return {...state, showAddUser: action.flag};
        case actions.SHOW_PERMISSION_LIST:
            return {...state, showPermissionList: action.flag};
        case actions.SHOW_ORDER_DETAIL:
            return Object.assign({},state,{showOrderDetail:action.flag});
        case actions.SHOW_ADD_PRODUCT:
            return {...state,showAddProduct:action.flag};
        case actions.SHOW_ALLOCATION_MODAL:
            return {...state,showAllocationModal:action.flag};
        case actions.SHOW_PRODUCT_DETAIL:
            return {...state,showProductDetail:action.flag};
        case actions.SHOW_COMMON_DETAIL:
            return {...state,showCommonDetail:action.flag};
        case actions.SHOW_ADD_GALLERY:
            return {...state,showAddGallery:action.flag};
        case actions.SHOW_ADD_CONSUMER:
            return {...state,showAddConsumer:action.flag};
        case actions.SHOW_ADD_COMMON:
            return {...state,showAddCommon:action.flag};
        case actions.SHOW_ADD_REDPACKAGE_BALANCE:
            return {...state,showAddRedpackageBalance:action.flag};
        case actions.SHOW_ADD_REDPACKAGE_POST:
            return {...state,showAddRedpackagePost:action.flag};
        case actions.CHECK_RIGHT_DETAIL_SHOW:
            return {...state, showCheckRightDetail:action.flag};
        default:
            return state;
    }
};
//完整的当前用户信息请参考myInfo
let user = (state = {}, action)=> {
    let obj;
    let data = action.data;
    switch (action.type) {
        case AjaxAction.USER_INFO:;
        case AjaxAction.LOGIN:
            obj = Object.assign({}, data);
            window.sessionStorage["nickname"] = data.nickname;
            window.sessionStorage['userId'] = data.id;
            window.sessionStorage['permissions'] = data.permissions;
            //document.cookie = `x-token=${data.token};domain=jfoto.cn`
            return obj;
        case AjaxAction.LOGOUT:
            delete window.sessionStorage['nickname'];
            delete window.sessionStorage['userId'];
            delete window.sessionStorage['permissions'];
            return state;
        case AjaxAction.AJAX_FAIL:
            let response = action.data;
            let code = response.code;
            if (code === "USER_TOKEN_MISS") {
                //特殊处理,这种情况下准备直接跳转页面了，所以不处理了
                delete window.sessionStorage['token'];
                return {loggedIn: false};
            }
        //其他情况的AJAX_FAIL下直接返回state
        //eslint-disable-next-line
        default:
            return state;
    }
};
 let userList = (state = [],action)=>{
     switch (action.type){
         case AjaxAction.USER_LIST:
             return action.data.data;
         default:
             return state;
     }
 };
 let departmentList = (state = [], action) =>{
     switch (action.type) {
         case AjaxAction.DEPARTMENT_LIST:
             return action.data.data;
         default:
             return state;
     }
 }
 let asyncUserList = (state = {}, action)=>{
     if(action.type == AjaxAction.USER_ONE) {
       // state[action.userId] = action.data || {};
       state= {
         ...state,
         [action.userId]:action.data || {}
       };
       // let nickname = state[action.userId].nickname;
       // window.localStorage.setItem(`user${action.userId}`, JSON.stringify({
       //     nickname:nickname || '异常',
       //     expires:nickname ? Date.now() + 86400 * 7 * 1000 : Date.now() + 60 * 10 * 1000
       // }));
     }
     else if(action.type == AjaxAction.USER_LIST) {
       let list = action.data.data;
       (list || []).forEach(user=>{
         if(!state[user.id] || !state[user.id].id) {
           // state[user.id] = user;
           state = {
             ...state,
             [user.id]:user
           };
           // window.localStorage.setItem(`user${user.id}`, JSON.stringify({
           //   nickname:state[user.id].nickname,
           //   expires:Date.now() + 86400 * 7 * 1000
           // }));
         }
       });
     }
     return state;
 }
let orderList = (state=[],action)=>{
    switch (action.type){
        case AjaxAction.ORDER_LIST:
            return action.data.data;
        default:
            return state;
    }
};
let productList = (state=[],action)=>{
    switch (action.type){
        case AjaxAction.PRODUCT_LIST:
            return action.data.data;
        default:
            return state;
    }
};

let sceneList = (state=[],action)=>{
    switch (action.type){
        case AjaxAction.SCENE_LIST:
            return action.data.data;
        default:
            return state;
    }
};

let remitList = (state=[],action)=>{
    switch (action.type){
        case AjaxAction.REMIT_LIST:
            return action.data.data;
        default:
            return state;
    }
};
let clueList = (state=[],action)=>{
    switch (action.type){
        case AjaxAction.CLUE_LIST:
            return action.data.data;
        default:
            return state;
    }
};
let oppoList = (state=[],action)=>{
    switch (action.type){
        case AjaxAction.OPPO_LIST:
            return action.data.data;
        default:
            return state;
    }
};
let contactList = (state=[],action)=>{
    switch (action.type){
        case AjaxAction.CONTACT_LIST:
            return action.data.data;
        default:
            return state;
    }
};
let areaList = (state=[], action)=>{
    switch(action.type) {
        case AjaxAction.AREA_LIST:
            return action.data.data;
        default:
            return state;
    }
};
let permissionList = (state = [],action)=>{
    switch (action.type){
        case AjaxAction.PERMISSION_USER_AUTH_LIST:
            return action.data;
        default:
            return state;
    }
};
const checkListObj =  (state={}, action)=>{
    switch(action.type) {
        case AjaxAction.CHECK_LIST:
            return action.data;
        default:
            return state;
    }
};
let currentUserPermissionList = (state = [], action)=>{
    switch (action.type){
        case AjaxAction.PERMISSION_DETAIL:
            return action.data;
        default:
            return state;
    }
};
let currentUser = (state = {}, action)=> {
    switch (action.type) {
        case actions.FILL_CURRENT_USER:
            return action.record;
        case actions.REMOVE_CURRENT_USER:
            return {};
        default:
            return state;
    }
};
let currentProduct = (state ={}, action)=>{
    return newCurrentX('product',state,action);
};
let currentRemit = (state = {},action)=>{
    return newCurrentX('remit',state,action);
}
let currentProxy = (state = {},action)=>{
    return newCurrentX('proxy',state,action);
}
let currentAgreement = (state={},action)=>{
    return newCurrentX('agreement',state,action);
}
let currentBill = (state = {},action)=>{
    return newCurrentX('bill',state,action);
};
let currentGallery = (state = {},action)=>{
    return newCurrentX('gallery', state, action);
};


const currentCheck = (state = {},action)=>{
    return newCurrentX('check', state, action);
};


let parentGallery = (state = {}, action)=>{
    switch(action.type) {
        case AjaxAction.GALLERY_PARENT:
            return action.data;
        default:
            return state;
    }
};
let currentConsumer = (state = {},action)=>{
    return newCurrentX('consumer',state,action);
};
let currentOrder = (state={},action)=>{
    state = newCurrentX('order', state, action);
    const {key, params} = action;
    switch (action.type){
        case actions.ORDER_COPY:
            return {
                ...state,
                copy:true,
            };
        case AjaxAction.CURRENT_ORDER_MODIFY:
            return {
                ...state,
                // 只用来做字符串的修改吧，
                [key]:params,
            }
        case AjaxAction.ORDER_TAGS:
          return {
            ...state,
            tags_detail:action.data
          };
        case AjaxAction.ORDER_CLEAR_TAGS:
          return {
            ...state,
            tags_detail:{}
          };
        case AjaxAction.ORDER_MODIFY_CHECK:
          return {
            ...state,
            check_detail:action.data
          };
        case AjaxAction.ORDER_MERGE_TAGS:
          return {
            ...state,
            tags_detail:{
              ...state.tags_detail,
              [action.category_id + ""]:action.tags
            }
          };
        default:
            return state;
    }
};

let currentClue = (state={},action)=>{
    return newCurrentX('clue',state,action);
};
let currentOppo  = (state={},action)=>{
    return newCurrentX('oppo',state,action);
};
let currentContact = (state={},action)=>{
    return newCurrentX('contact',state,action);
}
let image = (state = {},action)=>{
    switch (action.type){
        case AjaxAction.IMAGE_SIGN:
            return {
                ...state,
                sign:action.data
            };
        default: return state;
    }
};
let myInfo = (state = {},action)=>{
    switch (action.type){
        case AjaxAction.USER_DETAIL:
            return action.isMe ? action.data : state;
        default:
            return state;
    }
};
let qrcode = (state = {}, action)=>{
    switch(action.type) {
        case AjaxAction.QRCODE_EDIT:;
            //eslint-disable-next-line: no-fallthrought
        case AjaxAction.QRCODE_DETAIL:
            return {
                ...state,
                currentQrcode:action.data
            };
        default: return state;
    }
};

let im = (state = {}, action)=>{
    switch(action.type) {
        case AjaxAction.IM_LOGIN:
            return action.data.data;
        case AjaxAction.IM_LOGOUT:
            return {};
        default: return state;
    }
};

let imGroupList = (state = {}, action)=>{
    switch(action.type) {
        case AjaxAction.IM_GROUP_LIST:{
            console.log('imGroupList', action);
            return action.data;
        };
        case AjaxAction.IM_GROUP_UPDATE:{
          let list = state.imGroupList;
          let {id, data} = action;
          list = list.map(it=>{
            if(it.groupID == id) {
              it = {
                ...it,
                ...data
              };
            }
            return it;
          });

          return {
            ...state,
            imGroupList:list
          };
        };
        default: return state;
    }
};

let tagCategory = (state = null, action)=>{
  switch(action.type) {
    case AjaxAction.ORDER_TAGS_CATEGORY:
      return action.data;
      default: return state;
  }
};

let serviceUser = (state = null, action)=>{
    switch(action.type) {
        case AjaxAction.SERVICEUSER_TAG_LIST:
            return {
                ...state,
                tagList:action.data.data
            };
        case AjaxAction.SERVICEUSER_LIST:
            return {
                ...state,
                list:action.data.data
            };
        case AjaxAction.SERVICEUSER_DETAIL:
            return {
                ...state,
                current:action.data.data
            };
        case AjaxAction.SERVICEUSER_QUESTION_ORDER:
            return {
                ...state,
                current:{
                    ...state.current,
                    question_detail:action.data.data
                }
            }
        default: return {
            ...state
        };
    }
};

const appReducer =  combineReducers({
    myInfo,
    user,
    userList,
    departmentList,
    productList,
    clueList,
    oppoList,
    contactList,
    remitList,
    orderList,
    checkListObj,
    permissionList,
    currentUserPermissionList,
    ui,
    demo,
    currentUser,
    currentOrder,
    currentProduct,
    currentRemit,
    currentClue,
    currentOppo,
    currentContact,
    currentAgreement,
    currentGallery,
    currentCheck,
    parentGallery,
    currentConsumer,
    currentBill,
    currentProxy,
    image,
    areaList,
    sceneList,
    qrcode,
    asyncUserList,
    ...rateReducer,
    ...allocationReducer,
    ...checkReducer,
    im,
    tagCategory,
    imGroupList,
    serviceUser
})
export default (state, action) => {
    //登出后清除所有store
    if (action.type === AjaxAction.LOGOUT) {
        state = undefined
    }
    return appReducer(state, action);
}



// WEBPACK FOOTER //
// ./src/reducers/index.js